import {
  IntersectionObserverData,
  useIntersectionObserver,
} from "@tm/ui/hooks";
import { useCallback, useRef } from "react";
import { trackListingView } from "../../trackingUtils";
import {
  Card,
  Container,
  Icon,
  Rail,
  Subtitle,
  TextCol,
  Title,
} from "./Styles";

export interface ListingCarouselCard {
  icon?: string;
  title?: string;
  subtitle?: string;
}

interface ListingCarouselPersuasionProps {
  cards?: ListingCarouselCard[];
}

const TrackedCard = ({
  item,
  index,
}: {
  item: ListingCarouselCard;
  index: number;
}) => {
  const hasTracked = useRef(false);
  const handleIntersection = useCallback(
    (_data: IntersectionObserverData) => {
      if (!hasTracked.current) {
        trackListingView(`listing_carousel_card_${index + 1}_seen`);
      }
      hasTracked.current = true;
    },
    [index]
  );
  const { ref } = useIntersectionObserver(handleIntersection, {
    threshold: 0.5,
    triggerOnLeaveViewport: true,
  });

  return (
    <Card ref={ref}>
      {item.icon ? <Icon src={item.icon} alt="" /> : null}
      <TextCol>
        <Title>{item.title}</Title>
        <Subtitle>{item.subtitle}</Subtitle>
      </TextCol>
    </Card>
  );
};

export const ListingCarouselPersuasion = ({
  cards,
}: ListingCarouselPersuasionProps) => {
  if (!cards?.length) return null;
  return (
    <Container>
      <Rail>
        {cards.map((item, idx) => (
          <TrackedCard key={`${item.title}-${idx}`} item={item} index={idx} />
        ))}
      </Rail>
    </Container>
  );
};
